var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFmp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 683 683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.51 94.21c84.17 38.85 174.45 64.57 267 78.57C579.71 69.59 468.73 0 341.5 0 152.89 0 0 152.9 0 341.5S152.89 683 341.5 683a339.85 339.85 0 0 0 173.56-47.36c-80.49-15.7-158.74-40-231.89-73.82l18.7-99.06c94.54 47.65 200.14 76.53 308.37 89.48a341.26 341.26 0 0 0 49.81-87.46c-118.35-11.5-234.78-40.1-341.9-88.14l18.58-98.56C443 329.61 561.46 358.79 681.9 369q1.1-13.6 1.1-27.5a343.39 343.39 0 0 0-6.37-65.85C565 263.62 455.36 236.46 353 192.42ZM219.25 404.48l-60.43-44.09-60.43 44.09 23.2-71.14L61 289.51l74.8.12 23-71.22 23 71.22 74.8-.12-60.6 43.83Z",
    "data-name": "FMP Temp Logo"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmp);
export default __webpack_public_path__ + "static/media/FMP.8da8b020d4f51118ae85c47b8fa7be84.svg";
export { ForwardRef as ReactComponent };